import { render, staticRenderFns } from "./rel-serv-supplier.vue?vue&type=template&id=3922fc22&scoped=true"
import script from "./rel-serv-supplier.vue?vue&type=script&lang=js"
export * from "./rel-serv-supplier.vue?vue&type=script&lang=js"
import style0 from "./rel-serv-supplier.vue?vue&type=style&index=0&id=3922fc22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3922fc22",
  null
  
)

export default component.exports